import {
  Alert,
  Box,
  Button,
  FormControl,
  FormHelperText,
  Icon,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  Link,
  Snackbar,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import axios from "axios";
import { useEffect, useState, KeyboardEvent, JSX } from "react";
import { useNavigate } from "react-router-dom";

import background from "../../assets/headerHome.jpg";
import { ReactComponent as Logo } from "../../assets/logosSvg/logoEasyBI.svg";
import checkToken from "../../services/CheckToken";
import generatedGitInfo from "../../gitHash/generatedGitInfo.json";
import useStyles from "./styles";
import { usePages } from "../../context/pageContext";
import { useNotification } from "../../componentes/notificationProvider";

export default function Login(): JSX.Element {
  const [showPassword, setShowPassword] = useState(false);
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [nullField, setNullField] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertServiceOpen, setAlertServiceOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const { setCheckLogin } = usePages();

  const url = (window as any)?.config?.REACT_APP_BASE_URL || "";
  const navigate = useNavigate();
  const notify = useNotification();
  const theme = useTheme();
  const styles = useStyles(theme);

  useEffect(() => {
    setTimeout(() => {
      tokenValidate();
    }, 200);

    async function tokenValidate() {
      const data = await checkToken();
      if (data) {
        setCheckLogin(true);
        navigate("/loadRedirect");
      } else {
        setCheckLogin(false);
      }
    }
  }, []);

  const handleLogin = async () => {
    if (!login || !senha) {
      setNullField(true);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${url}/login`, {
        login,
        senha,
      });
      const {
        usuarioCliente,
        perfilAlreadyExists,
        perfilCliente,
        logs,
        acessoClienteId,
        ...userData
      } = response.data;

      if (usuarioCliente.status) {
        localStorage.setItem(
          "1",
          JSON.stringify({
            usuarioCliente,
            perfilAlreadyExists,
            ...userData,
          })
        );
        if (perfilCliente)
          localStorage.setItem("perfil", JSON.stringify(perfilCliente));
        localStorage.setItem("login", JSON.stringify(login));
        localStorage.setItem("logs", JSON.stringify(logs));

        navigate("/loadRedirect");
      } else if (!usuarioCliente.status && perfilAlreadyExists) {
        setAlert(true);
      }
    } catch (error: any) {
      if (error.code && !error.response) {
        notify(error.code, error.message, "error");
      } else {
        notify(error.status, error?.response?.data.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") handleLogin();
  };

  return (
    <Box sx={styles.container}>
      {" "}
      <Paper sx={styles.paperRight}>
        <Logo style={styles.logo} />

        <Box sx={styles.formBox}>
          <Typography sx={styles.title}>Faça login na sua conta</Typography>
          <Typography sx={styles.subTitle}>
            Novo por aqui?
            <Link
              component="button"
              onClick={() => navigate("/cadastro")}
              sx={{ ...styles.link, ...styles.linkSpan }}
            >
              Cadastre-se ou contate-nos
            </Link>
          </Typography>
          <Stack width={"100%"} gap={"5px"}>
            <TextField
              label="E-mail"
              type="text"
              variant="filled"
              error={!login && nullField}
              onKeyDown={handleKeyDown}
              onChange={(e) => setLogin(e.target.value)}
            />
          </Stack>
          <Stack width={"100%"} gap={"5px"}>
            <TextField
              label="Senha"
              variant="filled"
              type={showPassword ? "text" : "password"}
              error={!senha && nullField}
              onKeyDown={handleKeyDown}
              onChange={(e) => setSenha(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
          <Stack width={"100%"} alignItems={"end"}>
            <Link
              component={"button"}
              onClick={() => navigate("/resetPassword")}
              sx={styles.link}
            >
              Esqueceu a senha?
            </Link>
          </Stack>

          <Button
            fullWidth
            variant="contained"
            disabled={loading}
            onClick={handleLogin}
          >
            Entrar
          </Button>
          <Stack width={"100%"} alignItems={"center"}>
            <Typography
              fontSize={"12px"}
              sx={{ opacity: "0.9" }}
              color={theme.palette.text.secondary}
            >
              Version: {window?.config?.REACT_APP_COMMIT_HASH || "1.0.0"}
            </Typography>
          </Stack>
        </Box>
      </Paper>
      <Paper sx={styles.paperLeft(background)}></Paper>
    </Box>
  );
}
